import managerData from '../../api/managers';
import Manager from '../../classes/manager';
import * as types from '../mutation-types';
/* eslint-disable indent */
const stateData = {
          all: []
      },
      getters   = {
          allManagers: s => s.all
      },
      actions   = {
          getAllManagers({ commit }) {
              managerData.getManagers(managers => {
                  commit(types.RECEIVE_MANAGERS, { managers });
              });
          }
      },
      mutations = {
          [types.RECEIVE_MANAGERS](state, { managers }) {
              if (state.all.length > 0 && !(state.all[0] instanceof Manager)) {
                  state.all.forEach(loaded => {
                      let match = managers.find(m => m.id === loaded.id);
                      if (typeof match !== 'undefined') {
                          match.merge(loaded);
                      }
                  });
              }
              state.all = managers;
          },
          [types.HIRE_MANAGER](state, { manager }) {
              state.all.find(m => m.id === manager.id).hire();
          }
      };

export default {
    state: stateData,
    getters,
    actions,
    mutations
};
